import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-ff0b5d54"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "hello" };
var _hoisted_2 = /*#__PURE__*/ _createTextVNode(" | Vue3 + Pinia + Vant4 + ViewPort + TS ");
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_4 = /*#__PURE__*/ _createTextVNode(" 组件多 v-model 示例： ");
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_6 = /*#__PURE__*/ _createTextVNode(" v-model title ");
var _hoisted_7 = ["value"];
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_9 = /*#__PURE__*/ _createTextVNode(" v-model name ");
var _hoisted_10 = ["value"];
export default /*#__PURE__*/ _defineComponent({
    name: 'HelloWorld',
    props: ['msg', 'title', 'name'],
    emits: ['update:title', 'update:name'],
    setup: function (__props, _a) {
        var emits = _a.emit;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", null, _toDisplayString(__props.msg), 1),
                _createElementVNode("p", null, [
                    _hoisted_2,
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _createElementVNode("input", {
                        type: "text",
                        value: __props.title,
                        onInput: _cache[0] || (_cache[0] = function ($event) { var _a; return (emits('update:title', (_a = $event.target) === null || _a === void 0 ? void 0 : _a.value)); })
                    }, null, 40, _hoisted_7),
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("input", {
                        type: "text",
                        value: __props.name,
                        onInput: _cache[1] || (_cache[1] = function ($event) { var _a; return (emits('update:name', (_a = $event.target) === null || _a === void 0 ? void 0 : _a.value)); })
                    }, null, 40, _hoisted_10)
                ])
            ]));
        };
    }
});
